
define('utility/string/string.pluralize',['require','jquery','string!addCommas'],function (require) {
    'use strict';

    var $ = require('jquery');
    var stringExtensions = require('string!addCommas');
    
    function pluralize(quantity, opts) {
        /* jshint validthis:true */
        opts = $.extend({ singular: this, plural: this + 's', showCount: false, round: true }, opts || {});
        if (opts.round) {
            quantity = Math.round(quantity);
        }
        return (opts.showCount ? stringExtensions.addCommas(quantity + '') + ' ' : '') + (quantity === 1 ? opts.singular : opts.plural);
    }

    return function (string, quantity, opts) {
        return pluralize.call(string, quantity, opts);
    };
});